import styled from 'styled-components'
import { colorDanger } from 'common/theme'

export const StyledDragDropFileUploader = styled.div<{ isDragActive: boolean; isDisabled: boolean }>`
  min-height: 120px;
  border: 2px dashed
    ${({ theme, isDragActive }) => (isDragActive ? theme.colors.primary : theme.colors.inputBorder || '#ced4da')};
  border-radius: 4px;
  background-color: ${({ theme, isDragActive }) => (isDragActive ? theme.colors.backgroundText || '#f7f8fa' : '#fff')};
  color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
  padding: 20px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.65 : 1)};
  transition: border-color 0.2s ease, background-color 0.2s ease;

  .dropzone-content {
    display: flex;
    flex-direction: column;
    max-width: 460px;
  }

  .dropzone-title {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
  }
`

export const StyledSelectedFiles = styled.div`
  .pending-upload-block {
    margin-top: 12px;
  }

  .uploaded-document-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px 12px;
  }

  .uploaded-document-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme.colors.inputBorder || '#ced4da'};
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.backgroundText || '#f7f8fa'};
    font-size: 13px;
  }

  .uploaded-document-name {
    min-width: 0;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
  }

  .remove-document-button {
    padding: 0;
    min-width: auto;
    font-size: 13px;
    line-height: 1.4;
    white-space: nowrap;
  }
`

export const StyledFileUploaderError = styled.div`
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: ${colorDanger};
`
